import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../helpers/Records';
import { construct, resolve, resolveAll } from '../../helpers/LinkMapper';
import PaperSeasonTicket from './PaperSeasonTicket';

const fieldSchema = {
    "reasons": [ resolveAll.with(String) ],
    "ticket": [ resolve.as(PaperSeasonTicket) ]
};

class InvalidPaperSeasonTicket extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(InvalidPaperSeasonTicket, json, getResolvers(fieldSchema));
    }
}

export default InvalidPaperSeasonTicket;
